export enum ERoomUsage {
    OccasionallyVisited = 1,
    Evacuated = 2,
    KeptInOperation = 3,
    LivingRoom = 4,
    NonConcerne = 5
}
